export const betweenChips = "var(--seed-dimension-spacing-x-between-chips)";
export const globalGutter = "var(--seed-dimension-spacing-x-global-gutter)";